export default __webpack_public_path__ + "static/media/photo_left_2.2b0d97ee.png";